import { focusItems } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function FocusSection() {
  const [lead, ...rest] = focusItems;

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-8">
        <SectionHeading
          kicker="今日焦点"
          title="把三张截图摆在一起，故事自己就出来了"
          desc="每一条都给出一句短摘要，先看结论，再决定要不要点开整组高清原图。"
          actionLabel="全部焦点"
          actionHref="#ranking"
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
          <article className="lg:col-span-7 group">
            <a href="#gallery" className="block">
              <div className="relative aspect-[16/11] w-full overflow-hidden rounded-lg border border-background-200 bg-background-100">
                <img
                  src={lead.image}
                  alt={lead.title}
                  title={`${lead.title} - 黑料图片实锤截图`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute left-4 top-4 rounded-md bg-primary-500 px-2.5 py-1 text-[11px] font-semibold tracking-wide text-background-50">
                  {lead.tag}
                </span>
              </div>
              <div className="mt-5">
                <h3 className="font-heading text-xl font-bold leading-snug text-foreground-950 group-hover:text-primary-600 md:text-2xl">
                  {lead.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{lead.summary}</p>
                <div className="mt-4 flex flex-wrap items-center gap-4 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-time-line" />
                    {lead.time}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line" />
                    {lead.views} 次浏览
                  </span>
                </div>
              </div>
            </a>
          </article>

          <div className="flex flex-col gap-6 lg:col-span-5">
            {rest.map((item) => (
              <article key={item.id} className="group">
                <a
                  href="#gallery"
                  className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300"
                >
                  <div className="h-24 w-24 shrink-0 overflow-hidden rounded-md bg-background-100 md:h-28 md:w-28">
                    <img
                      src={item.image}
                      alt={item.title}
                      title={`${item.title} - 黑料图片聊天记录`}
                      className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                    />
                  </div>
                  <div className="flex min-w-0 flex-col">
                    <span className="mb-1 inline-flex w-fit items-center gap-1 rounded-md bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-900">
                      {item.tag}
                    </span>
                    <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-600">
                      {item.title}
                    </h3>
                    <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                      {item.summary}
                    </p>
                    <span className="mt-2 text-[11px] text-foreground-500">{item.time}</span>
                  </div>
                </a>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}